export default {
  LIST: {
    TITLE: `Structure`,
    SUMMARY: `Déterminez la manière dont votre horaire est affiché.`
  },
  QUIT_PAGE: `Les modifications apportées n'ont pas été sauvegardées. Souhaitez vous quitter quand même?`
}
